import { NotionPageListItem } from "../data/notionPagesCache";

/**
 * Filter the in-memory workspace list. Titles that START with the query come
 * first: with the whole workspace in the list, "not" otherwise buries "Notes"
 * under every page that merely mentions the word.
 */
export const filterNotionPages = (
  pages: readonly NotionPageListItem[],
  query: string,
): NotionPageListItem[] => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) {
    return [...pages];
  }

  const prefix: NotionPageListItem[] = [];
  const contains: NotionPageListItem[] = [];
  for (const page of pages) {
    const title = (page.title ?? "").toLowerCase();
    if (title.startsWith(normalizedQuery)) {
      prefix.push(page);
    } else if (title.includes(normalizedQuery)) {
      contains.push(page);
    }
  }
  return [...prefix, ...contains];
};

/**
 * Local matches first; remote-only pages appended; deduped by id.
 *
 * A page with no id is dropped rather than shown: it cannot be deduped against
 * the other side, and every row action (generate, add-as-card, link) keys on the
 * id, so the row would be inert.
 */
export const mergeNotionPages = (
  local: readonly NotionPageListItem[],
  remote: readonly NotionPageListItem[],
): NotionPageListItem[] => {
  const seen = new Set<string>();
  const merged: NotionPageListItem[] = [];

  for (const page of [...local, ...remote]) {
    if (page.id && !seen.has(page.id)) {
      seen.add(page.id);
      merged.push(page);
    }
  }

  return merged;
};
